import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDataProvider } from "./context/DataContext";
import { useAuth } from "./hooks/useAuth";
import AdminPanel from "./Admin/AdminPanel";

const Categories = () => {
  let { branch, catIndex } = useParams();
  const navigateTo = useNavigate();
  const { isAdmin } = useAuth();
  const { data } = useDataProvider();
  const [categories, setCategories] = useState([]);


  const getCategories = () => {
    let categories = [];
    data.map((item, index) => {
      categories.push({
        categoryName: item.categoryName,
        categoryIndex: index,
      });
    });
    setCategories(categories);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <>
      {isAdmin && <AdminPanel />}
      <div className="btn-container" style={{borderBottom:"0.5px dotted hsl(210, 22%, 49%)", borderTop:"0.5px dotted hsl(210, 22%, 49%)", paddingBottom:".3rem", paddingTop:".3rem", width:"100%"}}>
        <button
          type="button"
          className="filter-btn"
          onClick={() => navigateTo(`/${branch}`)}
        >
          Tüm Kategoriler
        </button>
        {categories.map((category, index) => {
          return (
            <Link to={`/${branch}/${index}`}>
              <button
                type="button"
                className={`filter-btn ${
                  index == catIndex ? "active" : ""
                }`}
                key={index}
              >
                {category.categoryName}
              </button>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default Categories;
